export const iconFontAwesomeMoneyLariSign = (
	<i className="fa-solid fa-lari-sign"></i>
);
